import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import Quote from 'components/Quote';
import Stepper from 'components/Stepper';
import LinkIfState from 'components/StyledLink/LinkIfState';
import receiptIcon from '../../assets/icons/general/receipt.svg';

import ModalTaskDetails from './ModalTaskDetails';
import ModalResponsibility from './ModalResponsibility';

import {
  typeStatus,
  typeResponsibility,
  steps,
  textStatus,
} from '../../config/tasks';

import { Creators as TaskCreators } from '../../store/ducks/task';

import {
  Container,
  TaskHeaderDate,
  TaskHeaderDetails,
  TaskTitle,
  TaskStatus,
  TaskStatusTitle,
  TaskStatusDescription,
  TaskQuotes,
  QuotesTitle,
  QuotesEmpty,
  Quotes,
  TaskStepper,
  TaskStepperTitle,
  ArrowHeader,
  TextButton,
} from './styles';

export default function CardOpenOrders({ task }) {
  const dispatch = useDispatch();
  const [showQuotes, setShowQuotes] = useState(true);
  const [showDetails, setShowDetails] = useState(false);
  const [showResponsibility, setResponsibility] = useState(false);

  useEffect(() => {
    dispatch(TaskCreators.getTaskDetailsRequest(task.task_id));
  }, [task.task_id]);

  const convertB2bStatusToStepIndex = (b2b_status_id, stepsArray) => (
    !b2b_status_id ? -1 : stepsArray.findIndex(step => step.b2b_status_id === b2b_status_id)
  );
  const findB2BStatusActive = allStatus => (allStatus && allStatus.find(step => step.active));
  const statusB2BNotFound = (taskStatus) => {
    if (taskStatus.status === 'charged' || taskStatus.status === 'paid') {
      return textStatus(typeStatus.DONE);
    }
    if (taskStatus.status === 'hired') {
      return textStatus(typeStatus.HIRED);
    }
    if (taskStatus.pro_user.some(pro_user => !pro_user.selected)) {
      return textStatus(typeStatus.AWATING);
    }
    if (taskStatus.pro_user.length === 0) {
      return textStatus(typeStatus.CONFIRMED);
    }
    return textStatus(typeStatus.CONFIRMED);
  };

  const statusActive = findB2BStatusActive(task.task_status) || statusB2BNotFound(task);
  const b2bStatusId = statusActive && statusActive.b2b_status_id
    ? statusActive.b2b_status_id
    : 0;

  const stepResponsibility = task.task_status.some(
    taskStatus => taskStatus.b2b_status_id === typeStatus.CHANGED_RESPONSIBILITY,
  ) ? [{
      b2b_status_id: 2,
      text: <TextButton type="button" onClick={() => setResponsibility(true)}>Responsabilidade alterada</TextButton>,
    }] : [];

  const stepsComplete = [...steps, ...stepResponsibility].sort(
    (prev, current) => (prev.b2b_status_id - current.b2b_status_id),
  );

  const indexStepCurrent = convertB2bStatusToStepIndex(b2bStatusId, stepsComplete);

  const quotesApproved = (statusActive.b2b_status_id === typeStatus.CONFIRMED)
    ? []
    : (
      task.pro_user.some(pro_user => pro_user.selected)
        ? [task.pro_user.find(pro_user => pro_user.selected)]
        : task.pro_user
    );
  const sectionStatus = task.company_responsibility === typeResponsibility.TENANT
    ? 'yourResponsibility'
    : 'noResponsibility';

  return (
    <Container>
      <TaskHeaderDate>
        {task.created && `Data do pedido: ${new Date(task.created).toLocaleDateString()}`}
      </TaskHeaderDate>
      <LinkIfState
        state={showDetails}
        ifStateFalse={(
          <TaskHeaderDetails>
            {' '}
            <ArrowHeader />
          </TaskHeaderDetails>
        )}
        ifStateTrue={(
          <TaskHeaderDetails>
            {' '}
            <ArrowHeader show />
          </TaskHeaderDetails>
        )}
        onClick={setShowDetails}
      />
      <TaskTitle>
        {task.service}
      </TaskTitle>
      <TaskStatus>
        <TaskStatusTitle>
          {textStatus(b2bStatusId)[sectionStatus].description}
        </TaskStatusTitle>
        <TaskStatusDescription>
          {textStatus(b2bStatusId)[sectionStatus].help}
        </TaskStatusDescription>
        {
          (quotesApproved && quotesApproved.length > 0) && (
            <LinkIfState
              state={showQuotes}
              ifStateFalse="Mostrar Orçamentos"
              ifStateTrue="Ocultar Orçamentos"
              onClick={setShowQuotes}
            />
          )
        }
        <TaskQuotes>
          <QuotesTitle>
            {
              textStatus(
                b2bStatusId, quotesApproved && quotesApproved.length,
              )[sectionStatus].titleQuotes
            }
          </QuotesTitle>
          {
            !quotesApproved || !quotesApproved.length ? (
              <QuotesEmpty>
                <img src={receiptIcon} width="32" heigth="32" alt="Ícone de notificação" />
                <p><strong>Você ainda não recebeu nenhum orçamento.</strong></p>
                <p>Não se preocupe, os seus orçamentos aparecerão aqui</p>
              </QuotesEmpty>
            ) : (
              showQuotes && (
                <Quotes>
                  {
                    quotesApproved.map(quote => (
                      <Quote
                        key={`${quote.quote_id}_${quote.user_id}`}
                        quote={quote}
                        status={statusActive}
                        responsibility={task.company_responsibility}
                      />
                    ))
                  }
                </Quotes>
              )
            )
          }
        </TaskQuotes>
      </TaskStatus>
      <TaskStepper>
        <TaskStepperTitle>Situação do pedido</TaskStepperTitle>
        <Stepper steps={stepsComplete.map(step => step.text)} stepCurrent={indexStepCurrent} />
      </TaskStepper>
      <ModalTaskDetails open={showDetails} setModalIsOpen={setShowDetails} task={task} />
      <ModalResponsibility open={showResponsibility} setModalIsOpen={setResponsibility} />
    </Container>
  );
}
